import styled from 'styled-components'

export const BoldWarning = styled.div`
    font-weight: bold;
`
